import { Button } from 'antd';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { SpacingRow, SpacingUnit } from 'components/ui';
import { FormStatus } from 'entities/common';
import { useBasicFormStore } from 'stores/local';
import { useUploadFormStore } from 'stores/local/forms/UploadFormStore';

const FileUploadButtonNodes = () => {
  const { t } = useTranslation();
  const { enabledContinueButton } = useUploadFormStore();

  const basicFormStore = useBasicFormStore();

  const handleOnNextClick = React.useCallback(async () => {
    await basicFormStore.updateFormStatus(FormStatus.VALIDATION);
  }, [basicFormStore]);

  return (
    <SpacingRow hSpacing={SpacingUnit.unit2}>
      <Button
        disabled={!enabledContinueButton}
        key="01"
        onClick={handleOnNextClick}
      >
        {t('common.continue')}
      </Button>
    </SpacingRow>
  );
};

export default observer(FileUploadButtonNodes);
